import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import injectSheet from 'react-jss';
import { Dialog, FlatButton, CircularProgress } from 'material-ui';
import TextField from 'material-ui/TextField';
import { push as routerPush } from 'react-router-redux';
import { equals } from 'ramda';
import { closeModal as closeMassDialog, sendMessage } from './store/actions';
import CommentBox from '../contracting/generic-components/comment-box';
import ReviewPartners from '../marketing-materials/send-to-partners/review-partners';
import ExistingPartners from '../marketing-materials/send-to-partners/existing/container-existing';
import ImportFromEmail from '../marketing-materials/send-to-partners/import-from-email';
import UploadFile from '../marketing-materials/send-to-partners/upload-file';
import AddIndividually from '../marketing-materials/send-to-partners/add-individually';
import Title from './title';
import Confirmation from './confirmation';

const styles = {
  main: {
//    textAlign: 'center',
  },
  largeText: {
    fontSize: '25px',
    fontWeight: 500,
    margin: 0,
    padding: '50px',
    textAlign: 'center',
  },
  dialogBody: {},
  errorExplain: {
    color: 'rgb(255, 64, 129)',
    float: 'left',
    marginLeft: '150px',
    marginTop: '-5px',
    textAlign: 'center',
  },
  inputBox: {
    height: '35px',
  },
};

const initialState = {
  addPartnersMethod: '',
  attachedFiles: [],
  currentComment: '',
  currentStep: 0,
  filteredConnections: [],
  individualCompanyName: '',
  individualEmail: '',
  partnersToSendTo: [],
  searchField: '',
  selectedExistingPartners: [],
  sendingMM: false,
  sendToPartners: false,
  showAddIndividuallyDialog: false,
  showEmailImportDialog: false,
  showSelectFromPartnersDialog: false,
  showSelectMethod: false,
  showUploadFileDialog: false,
  subject: '',
  testMessageSent: false,
//  existingConnections: [],
};

class MassMessageDialog extends Component {
  constructor(props) {
    super(props);
    this.state = Object.assign({}, initialState);
  }
  componentWillReceiveProps(nextProps) {
    if (Array.isArray(nextProps.connections) && !equals(nextProps.connections, this.props.connections)) {
      this.setState({ filteredConnections: nextProps.connections });
    }
    if (this.props.sending && !nextProps.sending) {
      this.setState({ testMessageSent: true });
    }
  }
  nextStep() {
    let step = this.state.currentStep;
    if (this.state.currentStep < 2) step++;
    this.setState({ currentStep: step });
  }
  prevStep() {
    let step = this.state.currentStep;
    if (this.state.currentStep === 1) step--;
    this.setState({ currentStep: step });
  }
  closeMe() {
    this.setState(Object.assign({}, initialState), () => {
      this.props.closeMassDialog();
    });
  }
  handleComment = (input) => {
    this.setState({ currentComment: input });
  }
  handleAttachFile = (fileList) => {
    this.setState({ attachedFiles: fileList });
  }
  confirmComment = () => {
    this._confirmation.handleOpen();
  }
  submitComment = () => {
    this.nextStep();
    this.props.sendMessage({
      messageSubject: this.state.subject,
      messageText: this.state.currentComment,
      files: this.state.attachedFiles,
      partners: this.state.partnersToSendTo,
    });
  }
  submitCommentTest = () => {
    this.props.sendMessage({
      messageSubject: this.state.subject,
      messageText: this.state.currentComment,
      files: this.state.attachedFiles,
      partners: [{
        companyName: this.props.companyName,
        email: this.props.userEmail,
      }],
      test: true,
    });
  }
  handleCancel = () => {
    this.setState({ currentComment: '', attachedFiles: [] });
  }
  check = (item) => {
    switch (item.checkType) {
      case 'checkOne':
        this.setState({ selectedExistingPartners: this.state.selectedExistingPartners.concat([item.partner]) });
        break;
      case 'checkAll':
        const allConnections = this.state.filteredConnections.length > 0 ? this.state.filteredConnections : this.props.connections;
        this.setState({ selectedExistingPartners: [].concat(allConnections) });
        break;
      default:
        break;
    }
  }
  uncheck = (item) => {
    switch (item.checkType) {
      case 'uncheckOne':
        this.setState({ selectedExistingPartners: [].concat(this.state.selectedExistingPartners.filter(e => e.companyId !== item.partner.companyId)) });
        break;
      case 'uncheckAll':
        this.setState({ selectedExistingPartners: [] });
        break;
      default:
        break;
    }
  }
  _updateValue(type) {
    this.setState({ [type]: this.refs[type].getValue() });
  }
  render() {
    const { isItOpen, classes, userType } = this.props;
    const actionItems = [
      {
        text: 'Select from connections',
        icon: 'tc-icon-user',
        func: () => this.setState({
          addPartnersMethod: 'fromConnections',
          showSelectFromPartnersDialog: true,
        }),
      },
      {
        text: 'Import from email',
        icon: 'tc-icon-email',
        func: () => this.setState({
          addPartnersMethod: 'emailImport',
          showEmailImportDialog: true,
        }),
      },
      {
        text: 'Upload a file',
        icon: 'tc-icon-insert-drive-file',
        func: () => this.setState({
          addPartnersMethod: 'uploadFile',
          showUploadFileDialog: true,
        }),
      },
      {
        text: 'Add individually',
        icon: 'add-circle-icon',
        func: () => this.setState({
          addPartnersMethod: 'addIndividually',
          showAddIndividuallyDialog: true,
        }),
      },
    ];
    const sharedProps = {
      updateMMPartnerProp: (newState) => {
        // unselect all connection if some kind of filter is applied
        // if (!equals(newState.filteredConnections, this.state.filteredConnections)) this.setState({ selectedExistingPartners: [] });
        this.setState(newState);
      },
      MMPartnerReducer2: Object.assign({}, this.state, {
        existingConnections: this.props.connections || [],
        check: (item) => { this.check(item); },
        uncheck: (item) => { this.uncheck(item); },
      }),
    };
    const getSelectedMethod = () => {
      switch (this.state.addPartnersMethod) {
        case 'fromConnections':
          return (
            <ExistingPartners
              {...sharedProps}
            />
          );
        case 'emailImport':
          return (
            <ImportFromEmail
              {...sharedProps}
            />
          );
        case 'uploadFile':
          return (
            <UploadFile
              {...sharedProps}
            />
          );
        case 'addIndividually':
          return (
            <AddIndividually
              {...sharedProps}
            />
          );
        default:
          return (<span/>);
      }
    };
    const maxAllowed = {
      'basic': 20,
    }[this.props.companyPlan] || 200;
    const dialogActions = [[
      <div>
        {(this.state.partnersToSendTo.length > maxAllowed) ? <div className={classes.errorExplain}>You have selected too many partners ({this.state.partnersToSendTo.length} of {maxAllowed} max).<br/>Please delete some to continue.</div> : undefined}
        <FlatButton
          key={1}
          label="Cancel"
          disableTouchRipple
          primary
          onClick={() => { this.closeMe(); }}
        />
        <FlatButton
          key={2}
          label="Next"
          disableTouchRipple
          secondary
          onClick={() => { this.nextStep(); }}
          disabled={(this.state.partnersToSendTo.length < 1 || this.state.partnersToSendTo.length > maxAllowed)}
        />
      </div>,
    ], [
      <FlatButton
        label={this.props.sending ? 'Sending' : (this.state.testMessageSent ? 'Sent' : 'Send Test Email')}
        style={{ float: 'left' }}
        disableTouchRipple
        disabled={this.props.sending || ((this.state.currentComment.trim().length + this.state.attachedFiles.length) < 1)}
        onClick={() => { this.submitCommentTest(); }}
        secondary
        key={3}
      />,
      <FlatButton
        key={1}
        label="Back"
        disableTouchRipple
        primary
        onClick={() => { this.prevStep(); }}
      />,
      <FlatButton
        key={2}
        label="Send Message"
        disableTouchRipple
        secondary
        disabled={((this.state.currentComment.trim().length + this.state.attachedFiles.length) < 1)}
        onClick={() => { this.confirmComment(); }}
      />,
    ], [
      <FlatButton
        key={2}
        label="Ok"
        disableTouchRipple
        secondary
        disabled={(this.props.sending)}
        onClick={() => {
          this.closeMe();
          // redirect to the workspace/message page
          if (this.props.lastCreatedMessage) {
            this.props.routerPush(`/workspace/bulkmessages/${this.props.lastCreatedMessage}`);
          } else if (this.props.singleRecipient) {
            this.props.routerPush(`/workspace/${this.props.singleRecipient}/general`);
          }
        }}
      />,
    ]];
    const isSupplier = (userType === 'Supplier');
    const content = [
      <div>
          <div>
            {(this.state.addPartnersMethod !== '') ? getSelectedMethod() : <span/>}
            <ReviewPartners
              actionItems={actionItems}
              isSupplier={isSupplier}
              showActions={false}
              {...sharedProps}
            />
          </div>
      </div>,
      <div>
        <TextField
          hintText="Enter subject here..."
          ref="subject"
          onChange={this._updateValue.bind(this, 'subject')}
          fullWidth
          className={classes.inputBox}
          underlineShow={false}
          hintStyle={ { marginLeft: '10px' } }
          inputStyle={ {
            border: '1px solid #bfbfbf',
            bottom: '-10px',
            height: '28px',
            paddingLeft: '10px',
          }}
        /><br />
        <CommentBox
          comment={this.state.currentComment}
          handleInput={this.handleComment}
          attachFile={this.handleAttachFile}
          attachedFiles={this.state.attachedFiles}
          submitComment={this.submitComment}
          cancelComment={this.handleCancel}
          disableSend={(false)}
          hintText="Enter message body here..."
          hideActions
        />
      </div>,
      <h2 className={classes.largeText}>
        {
          this.props.sending ?
            <div style={{ marginTop: '20px', display: 'block', textAlign: 'center' }}>
              <CircularProgress />
              <br/>
              Sending Message
            </div> : <span/>
        }
        {
          (!this.props.sending && this.props.sendingError) ?
            <span>Unable to send message</span>
          : <span />
        }
        {
          (!this.props.sending && !this.props.sendingError) ?
            <span>Message Sent !</span>
          : <span />
        }
      </h2>,
    ];
    return (
    <Dialog
      // className="form-dialog"
      // ref="contractingErrorDialog"
      open={isItOpen}
      onRequestClose={() => {
        this.closeMe();
      }}
      title={<Title currentStep={this.state.currentStep} />}
      actions={dialogActions[this.state.currentStep]}
      // bodyStyle={{ padding: '24px 12px' }}
      // contentStyle={{ maxWidth: '500px' }}
    >
      <div className={classes.main}>
        <div className={classes.dialogBody}>{ content[this.state.currentStep]}</div>
      </div>
      <Confirmation
        ref={(confirmation) => { this._confirmation = confirmation; }}
        handleConfirm= {() => { this.submitComment(); }}
        howMany={this.state.partnersToSendTo.length}
      />
    </Dialog>
    );
  }
}

MassMessageDialog.propTypes = {
  classes: PropTypes.object,
  closeMassDialog: PropTypes.func,
  companyName: PropTypes.string,
  companyPlan: PropTypes.string,
  connections: PropTypes.array,
  isItOpen: PropTypes.bool,
  lastCreatedMessage: PropTypes.string,
  routerPush: PropTypes.func,
  sending: PropTypes.bool,
  sendingError: PropTypes.bool,
  sendMessage: PropTypes.func,
  singleRecipient: PropTypes.string,
  userEmail: PropTypes.string,
  userType: PropTypes.string,
};

const mapStateToProps = ({ massmessaging, user }) => ({
  companyName: user.getIn(['company', 'companyName']),
  companyPlan: user.getIn(['company', 'plan']),
  connections: massmessaging.connections,
  isItOpen: massmessaging.dialogOpen,
  lastCreatedMessage: massmessaging.lastCreatedMessage,
  sending: massmessaging.messageCreating,
  sendingError: massmessaging.messageCreateError,
  singleRecipient: massmessaging.singleRecipient,
  userEmail: user.getIn(['user', 'email']),
  userType: user.getIn(['user', 'type']),
});

export default connect(mapStateToProps, {
  closeMassDialog,
  sendMessage,
  routerPush,
})(injectSheet(styles)(MassMessageDialog));



// WEBPACK FOOTER //
// ./src/app/components/massmessaging/dialog.jsx